import { render, staticRenderFns } from "./HeaderReceipt.vue?vue&type=template&id=306d714b&scoped=true&"
import script from "./HeaderReceipt.vue?vue&type=script&lang=js&"
export * from "./HeaderReceipt.vue?vue&type=script&lang=js&"
import style0 from "./HeaderReceipt.vue?vue&type=style&index=0&id=306d714b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306d714b",
  null
  
)

export default component.exports